import { FC, SVGProps } from 'react';

export const ProCrownIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<g filter="url(#filter0_di_3080_812)">
			<path
				d="M5.175 20.25V18.3333H18.825V20.25H5.175ZM5.175 16.8958L3.93188 9.20521C3.89938 9.20521 3.86265 9.20936 3.8217 9.21767C3.78075 9.22597 3.74435 9.22981 3.7125 9.22917C3.30625 9.22917 2.9611 9.08925 2.67705 8.80942C2.393 8.52959 2.25065 8.19034 2.25 7.79167C2.24935 7.393 2.3917 7.05375 2.67705 6.77392C2.9624 6.49409 3.30755 6.35417 3.7125 6.35417C4.11745 6.35417 4.46293 6.49409 4.74893 6.77392C5.03493 7.05375 5.17695 7.393 5.175 7.79167C5.175 7.90347 5.16265 8.00729 5.13795 8.10313C5.11325 8.19896 5.08498 8.28681 5.05313 8.36667L8.1 9.70833L11.1469 5.61146C10.9681 5.48368 10.8219 5.31597 10.7081 5.10834C10.5944 4.9007 10.5375 4.67709 10.5375 4.4375C10.5375 4.0382 10.6798 3.69863 10.9645 3.41879C11.2492 3.13896 11.5944 2.99936 12 3C12.4056 3.00064 12.7511 3.14056 13.0364 3.41975C13.3218 3.69895 13.4638 4.0382 13.4625 4.4375C13.4625 4.67709 13.4056 4.9007 13.2919 5.10834C13.1781 5.31597 13.0319 5.48368 12.8531 5.61146L15.9 9.70833L18.9469 8.36667C18.9144 8.28681 18.8858 8.19896 18.8611 8.10313C18.8364 8.00729 18.8243 7.90347 18.825 7.79167C18.825 7.39236 18.9673 7.05279 19.252 6.77296C19.5367 6.49313 19.8819 6.35353 20.2875 6.35417C20.6931 6.35481 21.0386 6.49472 21.3239 6.77392C21.6093 7.05311 21.7513 7.39236 21.75 7.79167C21.7487 8.19097 21.6067 8.53054 21.3239 8.81038C21.0412 9.09021 20.6957 9.22981 20.2875 9.22917C20.255 9.22917 20.2186 9.22533 20.1783 9.21767C20.138 9.21 20.1013 9.20585 20.0681 9.20521L18.825 16.8958H5.175Z"
				fill="url(#paint0_linear_3080_812)"
			/>
		</g>
		<defs>
			<filter
				id="filter0_di_3080_812"
				x="2.25"
				y="3"
				width="20.25"
				height="18"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dx="0.75" dy="0.75" />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0" />
				<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3080_812" />
				<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3080_812" result="shape" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dx="0.5" dy="0.5" />
				<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
				<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
				<feBlend mode="normal" in2="shape" result="effect2_innerShadow_3080_812" />
			</filter>
			<linearGradient id="paint0_linear_3080_812" x1="12" y1="3" x2="12" y2="20.25" gradientUnits="userSpaceOnUse">
				<stop stopColor="#866100" />
				<stop offset="1" stopColor="#FFB700" />
			</linearGradient>
		</defs>
	</svg>
);
